// This composable is used to provide the value for a field based on the field name
import { useAfterwardFields } from '@/components/documents/Foxit/FormMapping/composables/AfterwardFields'
import { useCashAdvanceFields } from '@/components/documents/Foxit/FormMapping/composables/CashAdvanceFields'
import { useCemeteryFields } from '@/components/documents/Foxit/FormMapping/composables/CemeteryFields'
import { useFamilyTravelFields } from '@/components/documents/Foxit/FormMapping/composables/FamilyTravelFields'
import type { MappedCartItem } from '@/components/documents/Foxit/FormMapping/composables/FormFillHelper'
import { useIdentityFields } from '@/components/documents/Foxit/FormMapping/composables/IdentityFields'
import { useMerchandiseFields } from '@/components/documents/Foxit/FormMapping/composables/MerchandiseFields'
import { useOtherFields } from '@/components/documents/Foxit/FormMapping/composables/OtherFields'
import { usePackageFields } from '@/components/documents/Foxit/FormMapping/composables/PackageFields'
import { usePaymentFields } from '@/components/documents/Foxit/FormMapping/composables/PaymentFields'
import { useServiceFields } from '@/components/documents/Foxit/FormMapping/composables/ServiceFields'
import { useTransportationFields } from '@/components/documents/Foxit/FormMapping/composables/TransportationFields'

export type FieldValueResult = {
	name: string
	value: string | number | undefined
	format: boolean
	section: string
	supplementalItems?: MappedCartItem[]
	// A total the PDF can calculate itself
	isTotal?: boolean
}

type FieldValueProvider =
	| ((param: string) => FieldValueResult[])
	| ((param: Record<string, string>) => FieldValueResult[])

type FieldToValueMap = Record<string, FieldValueProvider>

export const useFieldValueProvider = () => {
	const packageFields = usePackageFields()
	const serviceFields = useServiceFields()
	const merchandiseFields = useMerchandiseFields()
	const cashAdvanceFields = useCashAdvanceFields()
	const identityFields = useIdentityFields()
	const transportationFields = useTransportationFields()
	const cemeteryFields = useCemeteryFields()
	const afterwardFields = useAfterwardFields()
	const familyTravelFields = useFamilyTravelFields()
	const paymentFields = usePaymentFields()
	const otherFields = useOtherFields()

	const fieldToValueMap: FieldToValueMap = {
		...packageFields,
		...serviceFields,
		...merchandiseFields,
		...cashAdvanceFields,
		...identityFields,
		...transportationFields,
		...cemeteryFields,
		...afterwardFields,
		...familyTravelFields,
		...paymentFields,
		...otherFields,
	}

	const fieldToValue = (
		fieldName: string,
		formFieldName: string & Record<string, string>
	): FieldValueResult[] => {
		return fieldToValueMap[fieldName](formFieldName)
	}

	return {
		fieldToValue,
	}
}
